import classNames from 'classnames/bind';
import React, { Component } from 'react';

import { FieldInput } from 'reactApp/components/Forms/FieldInput';
import { getIn } from 'reactApp/components/Forms/formUtils';

import styles from './FieldPlanParams.css';

const css = classNames.bind(styles);

export class FieldPlanParams extends Component {
    render() {
        const {
            hourFieldName,
            minuteFieldName,
            storageOptionFieldName,
            storageOptionLabel,
            hiddenTimeFields,
            errors,
        } = this.props;
        const errorText =
            getIn(errors, hourFieldName) ||
            getIn(errors, minuteFieldName) ||
            getIn(errors, storageOptionFieldName);

        return (
            <>
                <div className={css('planParams')}>
                    {!hiddenTimeFields && (
                        <div className={css('timeWrapper')}>
                            <span className={css('label', 'hour')}>
                                Время начала
                            </span>
                            <div className={css('time')}>
                                <FieldInput
                                    name={hourFieldName}
                                    className={css('hourInput')}
                                    maxLength={2}
                                    hideErrorAtField={true}
                                    noSystemSpinner={true}
                                    type="number"
                                />
                                <span className={css('label', 'minute')}>
                                    :
                                </span>
                                <FieldInput
                                    name={minuteFieldName}
                                    className={css('minuteInput')}
                                    maxLength={2}
                                    hideErrorAtField={true}
                                    noSystemSpinner={true}
                                    type="number"
                                />
                            </div>
                        </div>
                    )}
                    <div className={css('settingsWrapper')}>
                        <FieldInput
                            label={storageOptionLabel}
                            name={storageOptionFieldName}
                            hideErrorAtField={true}
                            noSystemSpinner={true}
                            type="number"
                        />
                    </div>
                </div>
                <div className={css('errorWrapper')}>{errorText}</div>
            </>
        );
    }
}
